import script from "./StudentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudentView.vue?vue&type=script&lang=ts&setup=true"

import "./StudentView.vue?vue&type=style&index=0&id=62dd65ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62dd65ee"]])

export default __exports__